import { createSlice } from '@reduxjs/toolkit'
import api from '../../Core/Services/Api'
import { ofType } from 'redux-observable'
import { from } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { manageMapEpicResponse } from '../../Common/Utils/Api'
import { apiMapSlice } from '../../Common/Utils/Redux'

const emptyData = []

// reducer
const canLoggerMessagesSlice = createSlice(apiMapSlice('canLoggerMessages'))

export const { request, success, failure } = canLoggerMessagesSlice.actions

export default canLoggerMessagesSlice.reducer

export const selectCanLoggerMessages = (state) => state.canLoggerMessages
export const selectCanLoggerMessagesData = id => (state) => state.canLoggerMessages.data[id]?.value || emptyData
export const selectCanLoggerMessagesFetching = id => (state) => state.canLoggerMessages.fetching[id]
export const selectCanLoggerMessagesFetched = id => (state) => state.canLoggerMessages.fetched[id]

// side effects
export const fetchCanLoggerMessagesEpic = (action$) =>
  action$.pipe(
    ofType('canLoggerMessages/request'),
    mergeMap((action) => {
      return from(api.canLoggerConfigurations.getMessages(action.payload)).pipe(
        ...manageMapEpicResponse(
          action.payload, // the map id
          success,
          failure,
          'configurator:errors.FetchCanLoggerMessagesError',
        ),
      )
    }),
  )
